import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
import _isString from "lodash/isString";
import _isNumber from "lodash/isNumber";
import _isEqual from "lodash/isEqual";
import _isArray from "lodash/isArray";

var _dec, _dec2, _class, _descriptor, _descriptor2;

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { BlendType, gl, lazyInject, TYPES } from '@antv/l7-core';
import { rgb2arr } from '@antv/l7-utils';
import { color } from 'd3-color';
import { BlendTypes } from '../utils/blend';
var BaseModel = (_dec = lazyInject(TYPES.IGlobalConfigService), _dec2 = lazyInject(TYPES.IShaderModuleService), (_class = function () {
  function BaseModel(layer) {
    _classCallCheck(this, BaseModel);

    _defineProperty(this, "triangulation", void 0);

    _defineProperty(this, "createTexture2D", void 0);

    _defineProperty(this, "layer", void 0);

    _defineProperty(this, "dataTexture", void 0);

    _defineProperty(this, "DATA_TEXTURE_WIDTH", void 0);

    _defineProperty(this, "rowCount", void 0);

    _defineProperty(this, "cacheStyleProperties", void 0);

    _defineProperty(this, "cellLength", void 0);

    _defineProperty(this, "cellProperties", void 0);

    _defineProperty(this, "cellTypeLayout", void 0);

    _defineProperty(this, "stylePropertyesExist", void 0);

    _defineProperty(this, "dataTextureTest", void 0);

    _initializerDefineProperty(this, "configService", _descriptor, this);

    _initializerDefineProperty(this, "shaderModuleService", _descriptor2, this);

    _defineProperty(this, "rendererService", void 0);

    _defineProperty(this, "iconService", void 0);

    _defineProperty(this, "fontService", void 0);

    _defineProperty(this, "styleAttributeService", void 0);

    _defineProperty(this, "mapService", void 0);

    _defineProperty(this, "cameraService", void 0);

    _defineProperty(this, "layerService", void 0);

    this.layer = layer;
    this.rendererService = layer.getContainer().get(TYPES.IRendererService);
    this.styleAttributeService = layer.getContainer().get(TYPES.IStyleAttributeService);
    this.mapService = layer.getContainer().get(TYPES.IMapService);
    this.iconService = layer.getContainer().get(TYPES.IIconService);
    this.fontService = layer.getContainer().get(TYPES.IFontService);
    this.cameraService = layer.getContainer().get(TYPES.ICameraService);
    this.layerService = layer.getContainer().get(TYPES.ILayerService);
    this.registerBuiltinAttributes();
    this.startModelAnimate();
    var createTexture2D = this.rendererService.createTexture2D;
    this.createTexture2D = createTexture2D;
    this.DATA_TEXTURE_WIDTH = 1024;
    this.rowCount = 1;
    this.cellLength = 0;
    this.cellProperties = [];
    this.cacheStyleProperties = {
      thetaOffset: undefined,
      opacity: undefined,
      strokeOpacity: undefined,
      strokeWidth: undefined,
      stroke: undefined,
      offsets: undefined
    };
    this.stylePropertyesExist = {
      hasThetaOffset: 0,
      hasOpacity: 0,
      hasStrokeOpacity: 0,
      hasStrokeWidth: 0,
      hasStroke: 0,
      hasOffsets: 0
    };
    this.dataTextureTest = this.layerService.getOESTextureFloat();

    if (!this.dataTextureTest) {
      this.dataTexture = this.createTexture2D({
        data: new Uint8ClampedArray(4),
        mag: gl.NEAREST,
        min: gl.NEAREST,
        width: 1,
        height: 1
      });
    }
  }

  _createClass(BaseModel, [{
    key: "clearLastCalRes",
    value: function clearLastCalRes() {
      this.cellProperties = [];
      this.cellLength = 0;
      this.stylePropertyesExist = {
        hasThetaOffset: 0,
        hasOpacity: 0,
        hasStrokeOpacity: 0,
        hasStrokeWidth: 0,
        hasStroke: 0,
        hasOffsets: 0
      };
    }
  }, {
    key: "getCellTypeLayout",
    value: function getCellTypeLayout() {
      if (this.dataTextureTest) {
        return [this.rowCount, this.DATA_TEXTURE_WIDTH, 0.0, 0.0, this.stylePropertyesExist.hasOpacity, this.stylePropertyesExist.hasStrokeOpacity, this.stylePropertyesExist.hasStrokeWidth, this.stylePropertyesExist.hasStroke, this.stylePropertyesExist.hasOffsets, this.stylePropertyesExist.hasThetaOffset, 0.0, 0.0, 0.0, 0.0, 0.0, 1.0];
      } else {
        return [1.0, 1.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, -1.0];
      }
    }
  }, {
    key: "dataTextureNeedUpdate",
    value: function dataTextureNeedUpdate(options) {
      var isUpdate = false;

      if (!_isEqual(options.thetaOffset, this.cacheStyleProperties.thetaOffset)) {
        isUpdate = true;
        this.cacheStyleProperties.thetaOffset = options.thetaOffset;
      }

      if (!_isEqual(options.opacity, this.cacheStyleProperties.opacity)) {
        isUpdate = true;
        this.cacheStyleProperties.opacity = options.opacity;
      }

      if (!_isEqual(options.strokeOpacity, this.cacheStyleProperties.strokeOpacity)) {
        isUpdate = true;
        this.cacheStyleProperties.strokeOpacity = options.strokeOpacity;
      }

      if (!_isEqual(options.strokeWidth, this.cacheStyleProperties.strokeWidth)) {
        isUpdate = true;
        this.cacheStyleProperties.strokeWidth = options.strokeWidth;
      }

      if (!_isEqual(options.stroke, this.cacheStyleProperties.stroke)) {
        isUpdate = true;
        this.cacheStyleProperties.stroke = options.stroke;
      }

      if (!_isEqual(options.offsets, this.cacheStyleProperties.offsets)) {
        isUpdate = true;
        this.cacheStyleProperties.offsets = options.offsets;
      }

      if (this.dataTexture === undefined) {
        isUpdate = true;
      }

      return isUpdate;
    }
  }, {
    key: "judgeStyleAttributes",
    value: function judgeStyleAttributes(options) {
      this.clearLastCalRes();

      if (options.opacity !== undefined && !_isNumber(options.opacity)) {
        this.cellProperties.push({
          attr: 'opacity',
          count: 1
        });
        this.stylePropertyesExist.hasOpacity = 1;
        this.cellLength += 1;
      }

      if (options.strokeOpacity !== undefined && !_isNumber(options.strokeOpacity)) {
        this.cellProperties.push({
          attr: 'strokeOpacity',
          count: 1
        });
        this.stylePropertyesExist.hasStrokeOpacity = 1;
        this.cellLength += 1;
      }

      if (options.strokeWidth !== undefined && !_isNumber(options.strokeWidth)) {
        this.cellProperties.push({
          attr: 'strokeWidth',
          count: 1
        });
        this.stylePropertyesExist.hasStrokeWidth = 1;
        this.cellLength += 1;
      }

      if (options.stroke !== undefined && !this.isStaticColor(options.stroke)) {
        this.cellProperties.push({
          attr: 'stroke',
          count: 4
        });
        this.stylePropertyesExist.hasStroke = 1;
        this.cellLength += 4;
      }

      if (options.offsets !== undefined && !this.isOffsetStatic(options.offsets)) {
        this.cellProperties.push({
          attr: 'offsets',
          count: 2
        });
        this.stylePropertyesExist.hasOffsets = 1;
        this.cellLength += 2;
      }

      if (options.thetaOffset !== undefined && !_isNumber(options.thetaOffset)) {
        this.cellProperties.push({
          attr: 'thetaOffset',
          count: 1
        });
        this.stylePropertyesExist.hasThetaOffset = 1;
        this.cellLength += 1;
      }
    }
  }, {
    key: "isStaticColor",
    value: function isStaticColor(stroke) {
      if (_isString(stroke)) {
        if (color(stroke)) {
          return true;
        } else {
          return false;
        }
      }

      return false;
    }
  }, {
    key: "getStrokeColor",
    value: function getStrokeColor(stroke) {
      if (this.isStaticColor(stroke)) {
        var strokeColor = rgb2arr(stroke);
        strokeColor[0] = strokeColor[0] ? strokeColor[0] : 0;
        strokeColor[1] = strokeColor[1] ? strokeColor[1] : 0;
        strokeColor[2] = strokeColor[2] ? strokeColor[2] : 0;
        strokeColor[3] = strokeColor[3] ? strokeColor[3] : 0;
        return strokeColor;
      } else {
        return [0, 0, 0, 0];
      }
    }
  }, {
    key: "isOffsetStatic",
    value: function isOffsetStatic(offsets) {
      if (_isArray(offsets) && offsets.length === 2 && _isNumber(offsets[0]) && _isNumber(offsets[1])) {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: "patchMod",
    value: function patchMod(d, count) {
      for (var i = 0; i < count; i++) {
        d.push(-1);
      }
    }
  }, {
    key: "patchData",
    value: function patchData(d, cellData, cellPropertiesLayouts) {
      var _iterator = _createForOfIteratorHelper(cellPropertiesLayouts),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var layout = _step.value;
          var attr = layout.attr,
              count = layout.count;
          var value = cellData[attr];

          if (value !== undefined) {
            if (attr === 'stroke') {
              d.push.apply(d, _toConsumableArray(rgb2arr(value)));
            } else if (attr === 'offsets') {
              if (this.isOffsetStatic(value)) {
                d.push(-value[0], value[1]);
              } else {
                d.push(0, 0);
              }
            } else {
              d.push(_isNumber(value) ? value : 1.0);
            }
          } else {
            this.patchMod(d, count);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "calDataFrame",
    value: function calDataFrame(cellLength, encodeData, cellPropertiesLayouts) {
      var encodeDatalength = encodeData.length;
      var rowCount = Math.ceil(encodeDatalength * cellLength / this.DATA_TEXTURE_WIDTH);
      var totalLength = rowCount * this.DATA_TEXTURE_WIDTH;
      var d = [];

      for (var i = 0; i < encodeDatalength; i++) {
        var cellData = encodeData[i];
        this.patchData(d, cellData, cellPropertiesLayouts);
      }

      for (var _i = d.length; _i < totalLength; _i++) {
        d.push(-1);
      }

      return {
        data: d,
        width: this.DATA_TEXTURE_WIDTH,
        height: rowCount
      };
    }
  }, {
    key: "getBlend",
    value: function getBlend() {
      var _this$layer$getLayerC = this.layer.getLayerConfig(),
          _this$layer$getLayerC2 = _this$layer$getLayerC.blend,
          blend = _this$layer$getLayerC2 === void 0 ? 'normal' : _this$layer$getLayerC2;

      return BlendTypes[BlendType[blend]];
    }
  }, {
    key: "getDefaultStyle",
    value: function getDefaultStyle() {
      return {};
    }
  }, {
    key: "getUninforms",
    value: function getUninforms() {
      throw new Error('Method not implemented.');
    }
  }, {
    key: "getAnimateUniforms",
    value: function getAnimateUniforms() {
      return {};
    }
  }, {
    key: "needUpdate",
    value: function needUpdate() {
      return false;
    }
  }, {
    key: "buildModels",
    value: function buildModels() {
      throw new Error('Method not implemented.');
    }
  }, {
    key: "initModels",
    value: function initModels() {
      throw new Error('Method not implemented.');
    }
  }, {
    key: "clearModels",
    value: function clearModels() {
      return;
    }
  }, {
    key: "getAttribute",
    value: function getAttribute() {
      throw new Error('Method not implemented.');
    }
  }, {
    key: "render",
    value: function render() {
      throw new Error('Method not implemented.');
    }
  }, {
    key: "registerBuiltinAttributes",
    value: function registerBuiltinAttributes() {
      throw new Error('Method not implemented.');
    }
  }, {
    key: "animateOption2Array",
    value: function animateOption2Array(option) {
      return [option.enable ? 0 : 1.0, option.duration || 4.0, option.interval || 0.2, option.trailLength || 0.1];
    }
  }, {
    key: "startModelAnimate",
    value: function startModelAnimate() {
      var _ref = this.layer.getLayerConfig(),
          animateOption = _ref.animateOption;

      if (animateOption.enable) {
        this.layer.setAnimateStartTime();
      }
    }
  }]);

  return BaseModel;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "configService", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "shaderModuleService", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class));
export { BaseModel as default };
//# sourceMappingURL=BaseModel.js.map